import {
  isTrolleyClientGetPricedTrolleyError,
  isTrolleyClientGetPricedTrolleyAuthenticationError,
  isTrolleyClientGetTrolleySummaryError,
  isTrolleyClientGetTrolleySummaryAuthenticationError,
} from '@johnlewispartnership/wtr-website-trolley-sdk';

import { logger } from 'logger';
import { getTrolleyNetworkErrorModal, unexpectedErrorModal } from 'constants/modals/modals';
import type { GetErrorModal } from 'types/react-query';

const isTrolleyGetAuthenticationError = (error: unknown) =>
  isTrolleyClientGetTrolleySummaryAuthenticationError(error) ||
  isTrolleyClientGetPricedTrolleyAuthenticationError(error);

const isTrolleyGetError = (error: unknown) =>
  isTrolleyClientGetTrolleySummaryError(error) ||
  isTrolleyClientGetPricedTrolleyError(error) ||
  isTrolleyGetAuthenticationError(error);

const getErrorMessage = (error: unknown) => {
  if (
    isTrolleyClientGetTrolleySummaryError(error) ||
    isTrolleyClientGetTrolleySummaryAuthenticationError(error)
  ) {
    return 'Failed to fetch trolley summary';
  }

  if (
    isTrolleyClientGetPricedTrolleyError(error) ||
    isTrolleyClientGetPricedTrolleyAuthenticationError(error)
  ) {
    return 'Failed to fetch priced trolley';
  }

  return 'Failed to fetch trolley';
};

const logTrolleyQueryError = (error: unknown) => {
  const errorDetails = error instanceof Error ? error : {};

  logger.error({
    payload: {
      message: getErrorMessage(error),
      service: 'trolley',
      errorDetails,
    },
  });
};

export const getTrolleyQueryErrorModal: GetErrorModal = ({ error }) => {
  if (isTrolleyGetError(error)) {
    logTrolleyQueryError(error);
    return getTrolleyNetworkErrorModal;
  }

  logTrolleyQueryError(error);

  return unexpectedErrorModal;
};
